
  import { defineComponent, PropType } from 'vue';

  export default defineComponent({
    name: 'PersonCard',
    props: {
      className: {
        type: String,
        default: '',
      },
      name: {
        type: String,
        default: '',
      },
      position: {
        type: String,
        default: '',
      },
      // TODO: заменить в верстке захардкоженный флаг
      // eslint-disable-next-line
      flag: {
        type: String as PropType<string | null>,
        default: '',
      },
      avatar: {
        type: String as PropType<string | null>,
        default: '',
      },
    },
    setup() {
      return {};
    },
  });
